import { forwardRef, type TextareaHTMLAttributes } from "react";
import { FIELD_ERROR, FIELD_FOCUS, FIELD_REST } from "./TextInput";

// Textarea — DS §4.9 (.fc-textarea). min-height 96px, vertical resize.

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
    { error, className = "", ...rest },
    ref,
) {
    const state = error ? FIELD_ERROR : `${FIELD_REST} ${FIELD_FOCUS}`;
    return (
        <textarea
            ref={ref}
            aria-invalid={error || undefined}
            className={[
                "w-full box-border min-h-24 resize-y bg-surface border rounded-[var(--radius-sm)] px-4 py-4",
                "font-sans text-base leading-[1.55] text-primary outline-none",
                "transition-[border-color,box-shadow] duration-[var(--dur-base)] ease-[var(--ease-out)]",
                "placeholder:text-tertiary",
                "disabled:bg-muted disabled:text-tertiary disabled:cursor-not-allowed disabled:border-border",
                state,
                className,
            ]
                .filter(Boolean)
                .join(" ")}
            {...rest}
        />
    );
});
